var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickbooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2145_25125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#2CA01C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82151 19.9952C4.82311 24.5168 8.46951 28.1936 12.9911 28.2336H14.1479V25.2112H12.9911C10.1879 25.976 7.29671 24.3232 6.53351 21.52C6.52711 21.4976 6.52231 21.4752 6.51591 21.4528C5.73031 18.6128 7.37511 15.6704 10.2055 14.8528H10.7831C11.5079 14.6944 12.2583 14.6944 12.9831 14.8528H15.7927V30.8992C15.7783 32.5968 17.1431 33.9856 18.8407 34.0016V11.6752H13.0087C8.45511 11.6992 4.78471 15.4096 4.80871 19.9632V19.9648L4.82151 19.9952ZM27.0215 11.6784H25.8647V14.8608H27.0215C29.8183 14.0976 32.7031 15.7456 33.4663 18.5408C33.4727 18.5616 33.4775 18.584 33.4839 18.6048C34.2647 21.4352 32.6247 24.3664 29.8055 25.1824H29.2279C28.5031 25.3408 27.7527 25.3408 27.0279 25.1824H24.2183V9.13756C24.2327 7.43996 22.8679 6.05116 21.1703 6.03516V28.3936H27.0023C31.5959 28.3216 35.2615 24.5408 35.1911 19.9472C35.1207 15.4544 31.4967 11.8288 27.0023 11.7584L27.0215 11.6784Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2145_25125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbooks);
export default __webpack_public_path__ + "static/media/quickbooks.41c542d5eb2ed5f0dbb319b09d1c8551.svg";
export { ForwardRef as ReactComponent };